import { useTranslation } from "react-i18next";
import { changeLocale } from "@/i18n/changeLocale";
import type { AppLocale } from "@/i18n/constants";
import { useAppTranslation } from "@/i18n/useAppTranslation";

type Props = {
  variant?: "desktop" | "mobile" | "navy";
};

export function LanguageToggle({ variant = "desktop" }: Props) {
  const { t } = useAppTranslation("nav");
  const { i18n } = useTranslation();
  const current = (i18n.language === "en" ? "en" : "es") as AppLocale;
  const navy = variant === "navy";

  return (
    <div
      role="group"
      aria-label={t("language")}
      className={`flex items-center gap-0.5 rounded-full p-1 ${
        navy ? "border border-white/15" : "border border-brand-primary/12 bg-white/70"
      }`}
    >
      {(["es", "en"] as const).map((locale) => {
        const active = current === locale;
        return (
          <button
            key={locale}
            type="button"
            lang={locale}
            aria-pressed={active}
            aria-label={locale === "es" ? t("languageEs") : t("languageEn")}
            onClick={() => {
              if (!active) void changeLocale(locale, current);
            }}
            className={`min-h-8 min-w-10 rounded-full px-2.5 text-xs font-semibold tracking-wide transition-colors ${
              variant === "mobile" ? "min-h-10 min-w-14 text-sm" : ""
            } ${
              active
                ? navy
                  ? "bg-white text-brand-primary"
                  : "bg-brand-primary text-white"
                : navy
                  ? "text-on-navy-muted hover:text-white"
                  : "text-ink-muted hover:text-brand-primary"
            }`}
          >
            {locale.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
